import {post} from './RequestUtil'

export const AdminRequestUtil = {
  login (params, callback) {
    post('/admin/login', params).then((response) => {
      callback && callback(response)
    })
  },
  logout (params, callback) {
    post('/admin/logout', params).then((response) => {
      callback && callback(response)
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/AdminRequestUtil.js